export const stringCleaning = (type, content) => {
  if (type === 'string') {
    return (content || '').replace(/'/g, "''");
  }
  return content;
}
